import {ChangeDetectionStrategy, Component} from '@angular/core';

import {Modal} from '@softline/ui-core';

import { InputComponent } from '@softline/ui-core';
@Component({
    selector: 'soft-create-checkliste-dialog',
    imports: [
    InputComponent
  ],
    templateUrl: './create-checkliste-dialog.component.html',
    styleUrl: './create-checkliste-dialog.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateChecklisteDialogComponent implements Modal<{ betreff: string } | null> {

  close!: (result: { betreff: string } | null) => void;

  registerCloseHandler(handler: (result: ({ betreff: string } | null)) => void) {
    this.close = handler;
  }
}
